// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import { ReactNode } from 'react';
import ServicePageTemplate from 'presentations/views/components/templates/ServicePageTemplate';
import StaticContentTemplate from 'presentations/views/components/templates/StaticContentTemplate';
import styled from '@emotion/styled';

interface Props {
  header: ReactNode;
  breadcrumbs: ReactNode;
  body: string;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  return (
    <ServicePageTemplate header={props.header} breadcrumbs={props.breadcrumbs}>
      <ListStyle>
        <StaticContentTemplate title={t('title')} content={props.body} />
      </ListStyle>
    </ServicePageTemplate>
  );
}

const ListStyle = styled.div`
  .resource-body ul {
    list-style: initial;
  }
  .resource-body ol {
    list-style: initial;
  }
`;
